import { Stack, Title } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';

import { TSDViewEditGoodsItemFormValues } from '@e-origin/contracts';

import { EditArray } from '@components';

interface GoodsItemStakeholdersProps {
  goodsItemForm: UseFormReturnType<TSDViewEditGoodsItemFormValues>;
  disabled: boolean;
}

export const GoodsItemStakeholders: React.FC<GoodsItemStakeholdersProps> = ({ goodsItemForm, disabled }) => {
  return (
    <Stack mt="md">
      <Title order={5} fw={600}>
        Additional supply chain actor
      </Title>
      <EditArray
        addButtonLabel="Add"
        addButtonDataPW="add-additional-supply-chain-actor-btn"
        form={goodsItemForm}
        inputs={[
          {
            type: 'MultiLang',
            label: 'Role',
            name: 'role',
            code: 'CL704',
            width: 49,
          },
          {
            type: 'Input',
            label: 'Identification number',
            name: 'identificationNumber',
            width: 40,
          },
        ]}
        arrayPath="additionalSupplyChainActor"
        disabled={disabled}
        codelistSystemsConfig={{}}
      />
    </Stack>
  );
};
